import { useState } from 'react'
import { useRouter } from 'next/navigation'

import { useForm } from 'react-hook-form'

import { getAllParams } from '@/utils/browser'

import { SIMULATION_LABEL } from '@/constants'

export const useCalculator = () => {
  const [isLoading, setIsLoading] = useState(false)

  const router = useRouter()

  const { control, setValue, watch, handleSubmit } = useForm({
    mode: 'onChange',
    defaultValues: {
      consultation_type: 'cpf_cnpj',
      report_type: 'advanced'
    }
  })

  const onSubmit = (data) => {
    setIsLoading(true)

    sessionStorage.setItem(SIMULATION_LABEL, JSON.stringify(data))

    const params = getAllParams('plano', 'personalizado')

    router.push(`/formulario/dados-basicos/${params}`)
  }

  return {
    control,
    isLoading,
    setValue,
    watch,
    handleSubmit,
    onSubmit
  }
}
